export default "__VITE_ASSET__c3y8nauq__"